export const SUPPORTED_FAVICON_FORMATS = [
  {
    ext: 'png',
    mime: ['image/png'],
  },
  {
    ext: 'ico',
    mime: ['image/x-icon'],
  },
] as const;
